"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = main;
// This file is loaded on any page load.
const app_1 = require("app");
const cloningAlert_1 = require("./security/cloningAlert");
function main() {
    (0, cloningAlert_1.default)();
    setAnalyticsUserId();
    initDynatraceTracking();
    InitCustomSoftwareGTMEvent();
}
function initDynatraceTracking() {
    const dtrum = window['dtrum'];
    // If opt-in is not enabled we can't control dynatrace monitoring.
    if (!dtrum || !dtrum.enable || !dtrum.disable)
        return;
    // Fires on CookieInformation init and then on changes in user consent.
    window.addEventListener('CookieInformationConsentGiven', function onCookieConsentChange() {
        const cookieCategoriesAcceptance = app_1.UtilService.getCookieCategoriesAcceptance();
        if (!cookieCategoriesAcceptance)
            return;
        if (cookieCategoriesAcceptance.functional) {
            dtrum.enable();
        }
        else {
            dtrum.disable();
        }
    });
}
function setAnalyticsUserId() {
    const analyticsUserId = app_1.UtilService.getAnalyticsUserId();
    if (!analyticsUserId)
        return;
    app_1.GTM.login(analyticsUserId);
}
// The logic should be migrated to components with software download links
function InitCustomSoftwareGTMEvent() {
    document.querySelectorAll('a').forEach(anchor => {
        const href = anchor.getAttribute('href');
        if (href === null || href === void 0 ? void 0 : href.includes('.exe')) {
            const anchorAreaLabel = anchor.getAttribute('aria-label');
            anchor.addEventListener('click', () => {
                app_1.GTM.download({
                    category: 'Software',
                    name: anchorAreaLabel || anchor.innerText,
                    page: location.href,
                    path: href,
                    type: 'exe',
                });
            });
        }
    });
}
